import { ReactComponent as AssignmentIcon } from '../../../Common/BootstrapIcons/assignment-late.svg';
import { ReactComponent as CommentIcon } from '../../../Common/BootstrapIcons/comment.svg';
import { ReactComponent as CopyIcon } from '../../../Common/BootstrapIcons/copy.svg';
import { ReactComponent as InfoIcon } from '../../../Common/BootstrapIcons/info.svg';
import { ReactComponent as LinkIcon } from '../../../Common/BootstrapIcons/link.svg';
import BespokeToggleButton from '../../../Functions/Bespoke/BespokeToggleButton';
import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import LazySelectList from '../../../Common/LazySelectList/LazySelectList';
import PromiseButton from '../../../Common/PromiseButton';
import React from 'react';
import reportConfigNavigation from '../../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import SelectOption from '../../../../infrastructure/types/SelectOption';
import ComponentType from '../../../../types/report/ComponentType';
import ComponentChangeLogIconAndAction from '../../../Common/Modals/ComponentChangeLogModal/ComponentChangeLogIconAndAction';
import CustomDropdown from '../../../Common/Dropdown/CustomDropdown';
import CustomDropdownOption from '../../../Common/Dropdown/CustomDropdownOption';

const getColumns = (
    onInfoClick: (id: number) => Promise<any>,
    onCommentClick: (id: number) => Promise<any>,
    onUrlClick: (id: number) => Promise<any>,
    onActionItemClick: (id: number) => Promise<any>,
    onCopyFieldClick: (id: number) => void,
    onBespokeToggleClick: (isBespoke: boolean, definition: ReportFieldDefinition) => void,
    getFieldReferences: (id: number) => Promise<CustomDropdownOption[]>,
    getCommentCount: (id: number) => number,
    getUrlCount: (id: number) => number,
    getActionItemCount: (id: number) => number,
    isBespoke: (id: number) => boolean,
    isReadOnly: boolean,
    fieldNumberHeaderName: string
): ColumnDefinition<ReportFieldDefinition>[] => {

    let columns: ColumnDefinition<ReportFieldDefinition>[] = [
        {
            header: 'Reference',
            getContent: x => x.number.toString(),
            width: '7%'
        },
        {
            header: `${fieldNumberHeaderName}`,
            getContent: x => x.rtsFieldNumber === undefined ? '' : x.rtsFieldNumber.toString(),
            width: '7%'
        },
        {
            header: 'Field Name',
            getContent: x => x.name,
            width: '20%',
            className: 'break-all'
        },
        {
            header: 'CN Field Format',
            width: '20%',
            getContent: x =>
                <div>
                    <div dangerouslySetInnerHTML={{ __html: x.format }}></div>
                </div>
        },
        {
            header: '',
            getContent: x =>
                <>
                    <div className='display-flex'>
                        <CustomDropdown
                            showOnlyDefaultTextAsSelected='References'
                            getOptions={() => getFieldReferences(x.id)}
                            value={x.name}
                            onOptionSelected={(option: CustomDropdownOption) => {
                                reportConfigNavigation.navigateToItem(option.component.htmlId || '');
                            }}
                        />
                        {
                            !isReadOnly &&
                            <div className='no-wrap'>
                                <BespokeToggleButton
                                    isBespoke={isBespoke(x.id)}
                                    onClick={isBespoke => onBespokeToggleClick(isBespoke, x)}
                                    style={{ verticalAlign: 'top', marginLeft: '40px' }} />
                            </div>
                        }
                        <PromiseButton className="custom-icon-button" enableOnErrorOnly={false} task={() => onInfoClick(x.id)}>
                            <CustomIcon icon={InfoIcon} title={iconTooltip.info} />
                        </PromiseButton>
                        <PromiseButton className="custom-icon-button" enableOnErrorOnly={false} task={() => onUrlClick(x.id)}>
                            <CustomIcon icon={LinkIcon} count={getUrlCount(x.id)} title={iconTooltip.complianceGuidance} />
                        </PromiseButton>
                        <PromiseButton className="custom-icon-button" enableOnErrorOnly={false} task={() => onCommentClick(x.id)}>
                            <CustomIcon icon={CommentIcon} count={getCommentCount(x.id)} title={iconTooltip.comments} />
                        </PromiseButton>
                        <PromiseButton className="custom-icon-button" enableOnErrorOnly={false} task={() => onActionItemClick(x.id)}>
                            <CustomIcon icon={AssignmentIcon} count={getActionItemCount(x.id)} title={iconTooltip.actionLog} />
                        </PromiseButton>
                        <button className="custom-icon-button" onClick={() => onCopyFieldClick(x.id)} disabled={isReadOnly}>
                            <CustomIcon icon={CopyIcon} title={iconTooltip.copy} />
                        </button>
                        {x.id &&
                            <ComponentChangeLogIconAndAction
                                id={x.id as number}
                                componentName={x.name}
                                componentType={ComponentType.CaseField} />
                        }
                    </div>
                </>
        }
    ];

    return columns;
};

export {
    getColumns
};